import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@Components/shadcn/ui/tabs";
import UserDetailsComponent from '@Pages/UserDetails/components/UserDetailsComponent';
import Channels from '@Pages/Channels';

const Setting = () => {
  const [workspaceName, setWorkspaceName] = useState('Aviral Saxena');

  const handleWorkspaceNameUpdate = () => {
    // TODO: Implement workspace name update logic
  };

  const handleRefreshPermissions = () => {
    // TODO: Implement refresh permissions logic
  };

  return (
    <div className="min-h-screen  p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-gray-100 rounded-lg">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#1C274C" strokeWidth="1.5"/>
              <path d="M2 12.88V11.12C2 10.5 2.5 9.98003 3.11 9.98003C4.11 9.98003 4.78 9.07003 4.52 8.09003C4.36 7.46003 4.69 6.81003 5.32 6.57003L7.03 5.87003C7.57 5.66003 8.17 5.90003 8.42 6.42003L8.54 6.67003C8.79 7.19003 9.39 7.43003 9.93 7.22003C10.47 7.01003 10.76 6.42003 10.51 5.90003L10.39 5.65003C10.14 5.13003 10.39 4.52003 10.92 4.31003L12.63 3.61003C13.26 3.37003 13.97 3.70003 14.13 4.33003C14.39 5.31003 15.34 5.89003 16.24 5.52003C16.83 5.27003 17.48 5.60003 17.72 6.23003L18.42 7.94003C18.63 8.48003 18.39 9.08003 17.87 9.33003L17.62 9.45003C17.1 9.70003 16.86 10.3 17.07 10.84C17.28 11.38 17.87 11.67 18.39 11.42L18.64 11.3C19.16 11.05 19.77 11.3 19.98 11.83L20.68 13.54C20.92 14.17 20.59 14.88 19.96 15.04C18.98 15.3 18.4 16.25 18.77 17.15C19.02 17.74 18.69 18.39 18.06 18.63L16.35 19.33C15.81 19.54 15.21 19.3 14.96 18.78L14.84 18.53C14.59 18.01 13.99 17.77 13.45 17.98C12.91 18.19 12.62 18.78 12.87 19.3L12.99 19.55C13.24 20.07 12.99 20.68 12.46 20.89L10.75 21.59C10.12 21.83 9.41 21.5 9.25 20.87C8.99 19.89 8.04 19.31 7.14 19.68C6.55 19.93 5.9 19.6 5.66 18.97L4.96 17.26C4.75 16.72 4.99 16.12 5.51 15.87L5.76 15.75C6.28 15.5 6.52 14.9 6.31 14.36C6.1 13.82 5.51 13.53 4.99 13.78L4.74 13.9C4.22 14.15 3.61 13.9 3.4 13.37L2.7 11.66C2.46 11.04 2.79 10.34 3.41 10.18C4.39 9.92003 4.97 8.97003 4.6 8.07003C4.35 7.48003 4.68 6.83003 5.31 6.59003" stroke="#1C274C" strokeWidth="1.5"/>
            </svg>
          </div>
          <h1 className="text-2xl font-semibold">Settings</h1>
        </div>

        <Tabs defaultValue="general" className="w-full">
          <TabsList className="bg-white border-b border-gray-200 w-full justify-start rounded-none px-6">
            <TabsTrigger value="general" className="data-[state=active]:border-b-2 data-[state=active]:border-purple-600 rounded-none">
              General
            </TabsTrigger>
            <TabsTrigger value="channels" className="data-[state=active]:border-b-2 data-[state=active]:border-purple-600 rounded-none">
              Channels
            </TabsTrigger>
          </TabsList>

          <TabsContent value="general" className="bg-white rounded-lg p-6 mt-6">
            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-semibold mb-4">General</h2>
                <p className="text-gray-600 mb-6">Change the settings for your current workspace</p> 
              </div>

              <UserDetailsComponent/>

              {/* <div className="pt-6 border-t border-gray-200">
                <h3 className="font-medium mb-2">Instagram Permissions</h3>
                <p className="text-sm text-gray-500 mb-4">
                  Instagram can unexpectedly lose the connection to your page permissions. If you encounter any trouble, like content not sending or setting not saving, always refresh your permissions first.
                </p>
                <button
                  onClick={handleRefreshPermissions}
                  className="w-full bg-purple-600 text-white py-2 rounded-lg hover:bg-purple-700 transition-colors"
                >
                  Refresh Permissions
                </button>
              </div> */}
            </div>
          </TabsContent>

          <TabsContent value="channels" className="bg-white rounded-lg p-6 mt-6">
            <div>
              <h2 className="text-xl font-semibold mb-4">Channels</h2>
              <p className="text-gray-600 mb-6">Manage your connected social media channels</p>
              
              {/* Add channel management content here */}
              <Channels />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Setting;